export class ObjectFieldDataType {
    Code: string;
    Name: string;
}